export default "__VITE_ASSET__CpuoZJQA__"